import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingMembershipFilesDocument,
  CreateTrainingMembershipFilesMutation,
  CreateTrainingMembershipFilesMutationVariables,
  MyTrainingsFilesDocument,
  TrainingMembershipsDocument,
  TrainingMembershipsFileDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingMembershipFilesMutation,
  CreateTrainingMembershipFilesMutationVariables
>

export const useBulkCreateTrainingMembershipFiles = (options?: Options) => {
  const [uploadMembershipFiles, { loading }] = useMutation(CreateTrainingMembershipFilesDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.bulkCreateTrainingsTrainingMembershipFile,
  })

  return {
    loading,
    uploadFiles(variables: CreateTrainingMembershipFilesMutationVariables) {
      return uploadMembershipFiles({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          TrainingMembershipsDocument,
          MyTrainingsFilesDocument,
          TrainingMembershipsFileDocument,
        ],
      })
    },
  }
}
